import React from 'react';

import classNames from 'classnames';

import {CartItemType} from '../../types';
import {BaseEditButtonConnected} from '../baseEditButton/baseEditButton';
import {BaseInfoRow} from '../baseInfoRowV2/baseInfoRow';
import {BaseItemImage} from '../baseItemImage/baseItemImage';
import {BaseRemoveButtonConnected} from '../baseRemoveButton/baseRemoveButton';
import {CartItemLabel as UhcLabel} from '../cartItemLabel/cartItemLabel';

import s from './baseCartItem.scss';

export type PropsType = {
    item: CartItemType;
    editable?: boolean;
    children: React.ReactNode;
};

/**
 * Component which display base information about cart item
 * @param {PropsType} props - component props
 * @returns {React.ReactElement} - component
 */
export const BaseCartItem: React.FC<PropsType> = ({children, editable = true, item}) => {
    return (
        <div className={s.item}>
            <div className={s.itemImage}>
                <BaseItemImage item={item} />
            </div>
            <div className={s.summary}>
                <div
                    className={classNames(s.heading, {
                        [s.headingRedesignCL]: item.type === 'contact_lenses',
                        [s.headingRedesignCLVista]: item.brand === 'Vista Plus',
                    })}
                >
                    <BaseInfoRow
                        dataTestName="frameName"
                        dataTestValue={item.name}
                        price={item.totalPrice}
                        specialPrice={item.row_total_discounted_price_without_tax}
                        title={item.window_name}
                        heading
                    />
                </div>
                <UhcLabel
                    id={item.id}
                    isUhc={item.is_uhc}
                    isUhcEligible={item.is_eligible_for_uhc}
                    name={item.name}
                />
                <div className={s.itemContentContainer}>
                    {children}
                    <div
                        className={classNames(s.newDesc, {
                            [s.newDescRedesignVista]: item.brand === 'Vista Plus',
                        })}
                    >
                        {editable && (
                            <>
                                <BaseEditButtonConnected item={item} />|{' '}
                            </>
                        )}
                        <BaseRemoveButtonConnected item={item} />
                    </div>
                </div>
            </div>
        </div>
    );
};
